import { maybePluralizeNoun } from "#app/utils/words.js";

/**
 * Days in date order as a short phrase for a sentence: "Fri Oct 2nd",
 * "Fri Oct 2nd or Sun Oct 4th", "Fri Oct 2nd, Sat Oct 3rd, Sun Oct 4th or
 * 2 other days". `formatDay` turns one date into its label.
 */
export function listDays(days, formatDay, { listed = 3 } = {}) {
  const labels = [...days]
    .sort((a, b) => a - b)
    .slice(0, listed)
    .map(formatDay);
  const others = days.length - labels.length;
  if (others > 0) {
    return `${labels.join(", ")} or ${maybePluralizeNoun(others, "other day")}`;
  }
  if (labels.length <= 1) return labels[0] ?? "";
  return `${labels.slice(0, -1).join(", ")} or ${labels[labels.length - 1]}`;
}
